import { render } from "./App.vue?vue&type=template&id=71388294&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=71388294&lang=scss&scoped=true"

import exportComponent from "D:\\ProjectsWeb\\road-maintenance-launcher\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71388294"]])

export default __exports__